"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.hhmmA = exports.MMDDYYYY = exports.MMMMYYYY = void 0;
var MMMMYYYY = 'MMMM YYYY';
exports.MMMMYYYY = MMMMYYYY;
var MMDDYYYY = 'MM/DD/YYYY';
exports.MMDDYYYY = MMDDYYYY;
var hhmmA = 'hh:mm A';
exports.hhmmA = hhmmA;
var displayFormats = {
  monthAndYear: MMMMYYYY,
  dateOnly: MMDDYYYY,
  timeOnly: hhmmA,
  dateAndTime: "".concat(MMDDYYYY, ", ").concat(hhmmA)
};
var _default = displayFormats;
exports["default"] = _default;